module.exports = __webpack_public_path__ + "img/logo-large.fb87636730e2c27a2e65408872134f48.svg";